
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Agency } from '../Model/InternalModel';
import { GetEnvVarService } from "../../service/get-env-var.service";

@Injectable()
export class InternalinvoiceService {
  private baseUrl: string;
  private InvociebaseUrl: string;
  storedAccessJwtToken = sessionStorage.getItem('token');
  constructor(private http: HttpClient, private getEnvVarService: GetEnvVarService) {
    this.baseUrl = this.getEnvVarService.getUserservicebaseurl();
    this.InvociebaseUrl = this.getEnvVarService.getInvoiceservicebaseurl();
  }

  // Method to get the agency list
  getAgencyList() {
    return this.http.get(this.baseUrl + `/api/Agency`).pipe(
      map(response => response as Agency[]),
      catchError(handleError),);
  }
  // Method to get the invoice grid
  GetInvoiceGrid(agencyID): Observable<any[]> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.storedAccessJwtToken}`
    });
    return this.http.get<any[]>(this.InvociebaseUrl + `/api/Invoice/` + agencyID, { headers }).pipe(
      map(response => response),
      catchError(handleError),
    );
  }


  // Get Order Grid data
  GetOrderGrid(agencyID): Observable<any[]> {
    return this.http.get<any[]>(this.InvociebaseUrl + `/api/Order/` + agencyID).pipe(
      map(response => response),
      catchError(handleError),);
  }
  // Method to get order popup grid load
  GetOrderInvoiceGrid(orderInvoiceid, agencyID): Observable<any[]> {
    return this.http.get<any[]>(this.InvociebaseUrl + `/api/OrderInvoice/` + agencyID + `/` + orderInvoiceid).pipe(
      map(response => response),
      catchError(handleError),);
  }
  
  getDownloadUrl(id: string): Observable<string> {
        //debugger;
        return this.http.get(this.InvociebaseUrl + `/api/aws/getDownloadUrl/` + id, { responseType: 'text' }).pipe(
            map(response => response as string),
            catchError(handleError),);
    }
}
function handleError(error: any) {
  // log error
  // could be something more sofisticated
  let errorMsg = error.message || ``;
  console.error(errorMsg);
  // throw an application level error
  return observableThrowError(errorMsg);
}
